import { AnalyticsEvent, trackClick } from '@bonusly/analytics';
import { Dropdown, DropdownInput, DropdownMenu, DropdownOption } from '@bonusly/design-system';

import { TimePeriod } from './types';

interface TimePeriodSelectorProps {
	selectedPeriod: TimePeriod;
	onPeriodChange: (period: TimePeriod) => void;
}

const TIME_PERIOD_OPTIONS = [
	{ value: '12w' as TimePeriod, label: '12 weeks' },
	{ value: '6m' as TimePeriod, label: '6 months' },
	{ value: 'ytd' as TimePeriod, label: 'YTD' },
	{ value: '1y' as TimePeriod, label: '1 year' },
	// { value: 'all' as TimePeriod, label: 'All time' },
];

export function TimePeriodSelector({ selectedPeriod, onPeriodChange }: TimePeriodSelectorProps) {
	const selectedOption = TIME_PERIOD_OPTIONS.find((option) => option.value === selectedPeriod);

	return (
		<Dropdown
			onChange={(option) => onPeriodChange(option)}
			value={selectedOption?.value}
			renderOption={(value) => TIME_PERIOD_OPTIONS.find((option) => option.value === value)?.label ?? ''}
			size="sm"
		>
			<DropdownInput fontSize="sm" w={28} minW={28} />

			<DropdownMenu>
				{TIME_PERIOD_OPTIONS.map((option) => (
					<DropdownOption
						key={option.value}
						value={option.value}
						{...trackClick(AnalyticsEvent.CheckIns.OverTimeTimePeriodSelected, {
							period: option.value,
							label: option.label,
						})}
					>
						{option.label}
					</DropdownOption>
				))}
			</DropdownMenu>
		</Dropdown>
	);
}
